import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  token: any;
  id: any;

  public appointment = {
    has_pacakge: false,
    package: {}
  }

  public updated: boolean = false;
  public offer: any = null;
  public saving: boolean = false;

  constructor(public api: ApiService, public datepipe: DatePipe) {
    this.token = localStorage.getItem('access_token');
    this.id = localStorage.getItem('id');
  }

  getPatientPackges(id: any) {
    this.api.get('package_patients/patient/' + id, this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;
        let packages: any[] = objects;
        return packages;
      },
      async error => { return error; }
    );
  }

  checkPackagesServices(id: any, service_id: any) {
    this.getPatientPackgeService(id, service_id);
  }

  /** Packages Service */
  getPatientPackgeService(id: any, service_id: any) {
    this.saving = true;
    const sub = this.api.get('package_patients/patient/' + id + '/service/' + service_id, this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;
        let packages: any = objects;

        if (packages) this.appointment.has_pacakge = true;
        else this.appointment.has_pacakge = false;
      });

    sub.add(() => { this.saving = false; });
  }

  checkServiceIfhasPackage(id: any) {
    const sub = this.api.get('packages/service/' + id, this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;
        this.appointment.package = objects;
      });

    sub.add(() => { this.saving = false; })
  }

  /** Appointment Service */
  deleteSchAppointment(schedual_id: any, appointment_id: any) {
    this.deleteAppointment(appointment_id, schedual_id);
  }

  deleteAppointment(id: any, schedual_id?: any, both?: boolean) {
    const sub = this.api.delete('appointments/' + id, this.token).subscribe(
      async data => { }
    );
    sub.add(() => { if (both) this.deleteSchedual(schedual_id); })
  }

  deleteSchedual(id: any) {
    this.api.delete('schedules/' + id, this.token).subscribe(
      async data => { }
    );
  }

  async getOffer() {
    this.api.get('offers/avaliable', this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;

        if (objects) this.offer = objects;
        else this.offer = null;
      },
      async error => { }
    );
  }

  getDoctors() {
    this.api.get('employees/role/doctor', this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;
        let doctors = objects;

        if (doctors.length > 0) {
          localStorage.setItem('doctors', JSON.stringify(doctors));
          this.updated = true;
        }
      },
      async error => { }
    );
  }

  isUpdated() {
    return this.updated;
  }
}
